import { createFileRoute } from "@tanstack/react-router";
import { TenantInfoForm } from "@client/components/admin/tenant-info/tenant-info-form";

export const Route = createFileRoute("/_app/tenant-settings/tenant-info")({
  component: TenantInfoForm,
});
